// extracted by mini-css-extract-plugin
export var checkboxContainer = "checkbox-module--checkboxContainer--6V5n5";
export var checkboxLabel = "checkbox-module--checkboxLabel--G+rVD";